import React from "react";
import { Image } from "../../../../../../../components/Image";
import "./style.css";

export const MobilePayRemainPopup = ({openPayRemainPopup, closePayPopup, display, userName}) => {
  return (
    <div className="pay-remain-popup" data-model-id="18137:740" style={{display: display ? "" : "none"}}>

      <div className="content">
        <div className="top-app-bar">
          <div className="headline">Did you know?</div>

          <div className="icon">
            <Image className="clear" alt="Clear" src="/static/image/questionnaire/weight-loss/payRemainPopup/clear-24px.png" onClick={closePayPopup} />
          </div>
        </div>

        <div className="contents">
          <p className="statistic">
            <span className="text-wrapper">83%</span>

            <span className="span"> of users who started their </span>

            <span className="text-wrapper">weight loss journey with Calo</span>

            <span className="span">
              {" "}
              advanced in their goals within the first month
            </span>
          </p>

          <Image src="/static/image/questionnaire/weight-loss/payRemainPopup/chart-container.png" alt="Chart container" className="chart-container" />

          <div className="message-container">
            <Image src="/static/image/questionnaire/weight-loss/payRemainPopup/vector.png" alt="Vector" className="vector" />

            <p className="message">
              <span className="text-wrapper-2">
                We want you to find success so we are offering the{" "}
              </span>

              <span className="text-wrapper">additional discount</span>

              <span className="text-wrapper-2"> on your </span>

              <span className="text-wrapper">Weight Loss Plan.</span>
            </p>
          </div>
        </div>

        <div className="bottom">
          <button className="button" onClick={openPayRemainPopup}>
            <div className="button-text-wrapper">
              <div className="button-text">Got It</div>
            </div>
          </button>

          <div className="navigation">
            <div className="handle" />
          </div>
        </div>
      </div>
    </div>
  );
};
